/* ==========================================================================
   Cart reward ladder + add-to-cart upsell popup

   Custom addition — NOT part of Eurus core. Safe to remove together with
   upsell-popup.liquid, upsell-rewards-bar.liquid, upsell-rewards-card.liquid
   and upsell-rewards.css.

   How it hooks into the theme: Eurus checks for an `xCartNoti` store in every
   add-to-cart path (product-cart.js, product-bundle.js, product-list.js,
   frequently-bought-together.js, buy-your-own-bundle.js). When that store
   exists and is enabled, the theme hands us the add-to-cart response and
   skips opening the cart drawer. We use that same hook, so no core theme
   file is patched and theme updates stay safe.
   ========================================================================== */

if (!window.Eurus.loadedScript.has('upsell-rewards.js')) {
  window.Eurus.loadedScript.add('upsell-rewards.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      const configEl = document.getElementById('ur-config');
      if (!configEl) return;

      let cfg;
      try {
        cfg = JSON.parse(configEl.textContent);
      } catch (e) {
        console.warn('upsell-rewards: bad config', e);
        return;
      }

      const tier1 = parseInt(cfg.tier1Qty, 10) || 2;

      const fill = (template, count) =>
        String(template || '')
          .replace(/\{count\}/g, count)
          .replace(/\{s\}/g, count === 1 ? '' : 's')
          .replace(/\{reward1\}/g, `<b>${cfg.tier1Label}</b>`);

      Alpine.store('xUpsellRewards', {
        open: false,
        count: parseInt(cfg.count, 10) || 0,
        items: [],

        get tier1Reached() {
          return this.count >= tier1;
        },
        get percent() {
          if (this.count <= 0) return 0;
          return Math.min(100, Math.round((this.count / tier1) * 100));
        },
        get message() {
          if (this.count < tier1) return fill(cfg.messages.before, tier1 - this.count);
          return fill(cfg.messages.done, 0);
        },

        money(cents) {
          if (cents === null || cents === undefined) return '';
          try {
            return new Intl.NumberFormat(cfg.locale, {
              style: 'currency',
              currency: cfg.currency
            }).format(cents / 100);
          } catch (e) {
            return (cents / 100).toFixed(2);
          }
        },

        /* Called by the theme with the /cart/add.js response. */
        show(response) {
          const list = response && response.items ? response.items : response ? [response] : [];

          this.items = list.map((item) => ({
            title: item.product_title || item.title,
            variant_title: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
            url: item.url || item.productUrl || '',
            image: item.image || (item.featured_image && item.featured_image.url) || '',
            price: item.price,
            final_line_price: item.final_line_price
          }));

          this.open = true;
          this.refresh();

          /* product-cart.js closes xPopup right after handing us the item, so
             claim the body scroll lock on the next frame instead of now. */
          requestAnimationFrame(() => {
            if (Alpine.store('xPopup')) Alpine.store('xPopup').open = true;
          });
        },

        close() {
          this.open = false;
          if (Alpine.store('xPopup')) Alpine.store('xPopup').close();
        },

        goToCart() {
          this.open = false;
          const miniCart = Alpine.store('xMiniCart');
          if (miniCart && miniCart.type === 'drawer' && document.getElementById('CartDrawer-Overlay')) {
            miniCart.openCart();
          } else {
            if (Alpine.store('xPopup')) Alpine.store('xPopup').close();
            window.location.href = cfg.cartUrl || '/cart';
          }
        },

        refresh() {
          fetch(`${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'}cart.js`)
            .then((r) => r.json())
            .then((cart) => {
              this.count = cart.item_count;
            })
            .catch(() => {});
        }
      });

      /* The extension point Eurus already looks for. Enabling it stops the
         drawer from auto opening on add — the popup takes its place. */
      Alpine.store('xCartNoti', {
        enable: true,
        listItem: [],
        show: false,
        setItem(response) {
          Alpine.store('xUpsellRewards').show(response);
        },
        open() {
          Alpine.store('xUpsellRewards').open = true;
        }
      });

      Alpine.data('xUpsellPopup', () => ({
        scrollRail(direction) {
          const rail = this.$refs.rail;
          if (!rail) return;
          const card = rail.querySelector('.ur-card');
          const step = card ? card.offsetWidth + 10 : 150;
          rail.scrollBy({ left: direction * step * 2, behavior: 'smooth' });
        }
      }));
    });
  });

  /* Quantity changes inside the drawer/cart also move the ladder. */
  document.addEventListener('eurus:cart:items-changed', () => {
    const store = window.Alpine && Alpine.store('xUpsellRewards');
    if (store) store.refresh();
  });
}